import { Image } from 'app/components/ui/Image'
import React from 'react'
import styled from 'styled-components'

export const ArrowSectionSeparator = (): JSX.Element => {
  return (
    <Wrapper>
      <Image
        src='https://res.cloudinary.com/estra/image/upload/v1629357549/estra20dev/sponsor/step_arrow.svg'
        alt='form_step_arrow_icon'
      ></Image>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  text-align: center;

  margin-top: 3rem;
  margin-bottom: 3rem;
`
